//#region
import axios from 'axios';
import { url, endPoint } from '../urls';
//#endregion


export function dashboardShare(params) {
    let _url = url.backendHost + endPoint.dashboardShareRoutes.dashboardShare;
    return axios.post(_url, params );
}

export function userTypeShare(params) {
    let _url = url.backendHost + endPoint.dashboardShareRoutes.userTypeShare;
    return axios.post(_url, params );
}


